export enum ROLES {
  STUDENT = "student",
  TEACHER = "teacher",
  PROVIDER = "provider",
}

export const ROLES_MAP: Record<ROLES, string> = {
  [ROLES.STUDENT]: "Elève",
  [ROLES.TEACHER]: "Professeur",
  [ROLES.PROVIDER]: "Partenaire",
};

export type EducationalAdvisorRole = ROLES.TEACHER | ROLES.PROVIDER;

const EDUCATIONAL_ADVISOR_ROLES: EducationalAdvisorRole[] = [ROLES.TEACHER, ROLES.PROVIDER];

export const isEducationalAdvisorRole = (role?: string | null): role is EducationalAdvisorRole => {
  return !!role && EDUCATIONAL_ADVISOR_ROLES.includes(role as EducationalAdvisorRole);
};
